export default function deleteHotspot(hotstpotClassName, index) {
  const customHotspots = document.querySelectorAll(hotstpotClassName);
  customHotspots.forEach((item, i) => {
    if (index === i) {
      item.classList.add("hide");
    }
  });
}
